export const validationCustomerBUS = {
  expiryDateRules: [(v) => !!v || "Expiry date is required"],
  locationRules: [
    (v) => !!v || "Issue Location is required",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Issue Location",
  ],
  issueDateRules: [(v) => !!v || "Issue date is required"],
  idtypeRules: [(v) => !!v || "ID Type is required"],
  idnumberRules: [
    (v) => !!v || "ID Number is required",
    (v) => /^[a-zA-Z0-9]+$/.test(v) || "Invalid ID Number",
  ],
  designationRules: [(v) => !!v || "Designation is required"],
  relationshipRules: [(v) => !!v || "Relationship is required"],
  sourceofFundRules: [(v) => !!v || "Source Of Funds is required"],
  occupationRules: [(v) => !!v || "Occupation is required"],
  CountryRules: [(v) => !!v || "Country is required"],
  StateRules: [(v) => !!v || "State is required"],
  typeoffbusiness: [(v) => !!v || "Type of Bussiness is required"],
  CityRules: [(v) => !!v || "City is required"],
  nameRules: [
    (v) => !!v || "Name is required",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Name",
  ],
  websiteRules: [
    (v) => !!v || "Website is required",
    (v) =>
      /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm.test(
        v
      ) || "Invalid Website",
  ],
  registred_numberrules: [
    (v) => !!v || "Registered Number is required",
    (v) => /^([a-zA-Z0-9])*$/.test(v) || "Invalid register number value",
  ],
  company_rules: [
    (v) => !!v || "Company name is required",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Company name",
  ],
  Directors_Shareholders_Name: [
    (v) => !!v || "Directors/Shareholders Name  is required",
    (v) =>
      /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Directors/Shareholders Name ",
  ],

  contactNumbrules: [
    (v) => !!v || "Contact Number is required",
    (v) => /^(([0-9]*){20})$/.test(v) || "The value must be an integer number",
    // (v) =>
    //   /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/.test(v) ||
    //   "The value must be an integer number",
    (v) => (v && v.length >= 8) || "Contact Number must be more than 8 Numbers",
    (v) =>
      (v && v.length < 13) || "Contact Number must be less than 13 Numbers",
  ],
  imagerules: [
    (v) => v.size <= 5000000 || "Image size should be less than 5 MB!",
  ],
  emailRules: [
    (v) => !!v || "E-mail is required",
    (v) =>
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      "E-mail must be valid",
  ],

  nationalityRules: [(v) => !!v || "Nationality is required"],
  addressRule: [
    (v) => !!v || "Address is required",
    (v) => /^([a-zA-Z0-9,.#'-/]+\s?)*$/.test(v) || "Invalid Address",
  ],
  genderRules: [(v) => !!v || "Gender is required"],
  pincodeRule: [(v) => !!v || "PIN Code is required"],
  titlesRule: [(v) => !!v || "Title is required"],
  dobRules: [(v) => !!v || "DOB is required"],
  EntityRules: [(v) => !!v || "Entity type   is required"],
};
export const runnerValidation = {
  banknamerules: [
    (v) => !!v || "Bank name is required",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Bank Name",
  ],
  accountholderrules: [
    (v) => !!v || "Account holder Name is required",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid  Account holder name",
  ],
  accountnumberrules: [
    (v) => !!v || "Account Number is required",
    (v) => /^(([0-9]*){20})$/.test(v) || "Invalid Account number",
  ],
  earningsrules: [
    (v) => !!v || "Earnings is required",
    (v) => /^(([0-9]*))$/.test(v) || "Invalid Earnings",
  ],
  earningType: [(v) => !!v || "Earning type is required"],
  pincodeRule: [(v) => !!v || "PIN Code is required"],
  titlesRule: [(v) => !!v || "Title is required"],
};

export const validation = {
  first_nameRules: [
    (v) => !!v || "First name is required.",
    (v) => !/[0-9]/.test(v) || "Invalid First name",
    (v) => !/\s{2,}/.test(v) || "Invalid First name",
  ],

  middle_nameRules: [
    (v) => !/[0-9]/.test(v) || "Invalid Middle Name",
    (v) => !/\s{2,}/.test(v) || "Invalid Middle name",
  ],
  parner_nameRules: [(v) => !!v || "Partner Name is required"],
  last_nameRules: [
    (v) => !!v || "Last name is required",
    (v) => !/[0-9]/.test(v) || "Invalid Last Name",
    (v) => !/\s{2,}/.test(v) || "Invalid Last name",
  ],
  relationshipRules: [(v) => !!v || "Relationship is required"],
  occupationRules: [(v) => !!v || "Occupation is required"],
  designationRules: [(v) => !!v || "Designation is required"],
  titlesRule: [(v) => !!v || "Title is required"],
  genderRules: [(v) => !!v || "Gender is required"],
  idtypeRules: [(v) => !!v || "ID Type is required"],
  CountryRules: [(v) => !!v || "Country is required"],
  CountryofbirthRules: [(v) => !!v || "Country Of Birth is required"],
  CityRules: [(v) => !!v || "City is required"],
  StateRules: [(v) => !!v || "State is required"],
  lockifnotrules: [(v) => !!v || "Lock if not login is required"],
  sourceofFundRules: [(v) => !!v || "Source Of Income is required"],
  departmentRules: [(v) => !!v || "Department is required"],
  assignedRules: [(v) => !!v || "Assign Role is required"],
  subdivisionRules: [(v) => !!v || "Sub Divison is required"],
  datelimitRules: [(v) => !!v || "Date Limit is required"],
  assinrulesRules: [(v) => !!v || "Assign Roles  is required"],
  branchnameRules: [
    (v) => !!v || "Branch Name is required",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Branch Name",
  ],
  translimitRules: [
    (v) => !!v || "Transaction limit is required",
    (v) => /^[a-zA-Z0-9]+$/.test(v) || "Invalid Transaction limit ",
  ],
  idnumberRules: [
    (v) => !!v || "ID Number is required",
    (v) => /^[a-zA-Z0-9]+$/.test(v) || "Invalid ID Number",
  ],
  locationRules: [
    (v) => !!v || "Issue Location is required",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Issue Location",
  ],
  expiryDateRules: [(v) => !!v || "Expiry date is required"],
  issueDateRules: [(v) => !!v || "Issue date is required"],
  passport_location: [(v) => !!v || "Passport loacation is required"],
  addressRule: [
    (v) => !!v || "Address is required",
    (v) => /^([a-zA-Z0-9,.#'-/]+\s?)*$/.test(v) || "Invalid Address",
  ],
  pincodeRule: [(v) => !!v || "PIN Code is required"],
  employerRules: [(v) => !!v || "Employer Name is required"],
  nationalityRules: [(v) => !!v || "Nationality is required"],
  user_typeRules: [(v) => !!v || "User Type is required"],
  staffidRules: [(v) => !!v || "Staff ID is required"],

  dobRules: [(v) => !!v || "DOB is required."],
  contactNumbrules: [
    (v) => !!v || "Contact Number is required",
    (v) => /^(([0-9]*){20})$/.test(v) || "The value must be an integer number",
    (v) => (v && v.length >= 8) || "Contact Number must be more than 8 Numbers",
    (v) =>
      (v && v.length < 13) || "Contact Number must be less than 13 Numbers",
  ],

  idnumericrule: [
    (v) => !!v || "ID Number is required",
    (v) => /^(([0-9]*)|(([0-9]*)))$/.test(v) || "Invalid Id number",
  ],
  imagerules: [
    (v) => v.size <= 5000000 || "Image size should be less than 5 MB!",
  ],
  emailRules: [
    (v) => !!v || "E-mail is required",
    (v) =>
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      "E-mail must be valid",
  ],
  branch_code: [
    (v) => /^([A-Za-z0-9]+\s?)*$/.test(v) || "Invalid Value Branch Code",
  ],
  // account_Number: [
  //   (v) => !!v || "Account Number is required",
  //   (v) => /^([A-Za-z0-9]+\s?)*$/.test(v) || "Invalid Value Account Number",
  // ],
  account_Number: [
    (v) => !!v || "Account Number is required",
    (v) => /^[0-9]*$/.test(v) || "Invalid Value Account Number",
    (v) => v.length >= 8 || "Account Number must be at least 8 digits",
    (v) => v.length <= 20 || "Account Number must be less than 20 digits",
    (v) => v !== "0".repeat(v.length) || "Account Number cannot be all zeros",
  ],
};

export const spBusvalidation = {
  EntityRules: [(v) => !!v || "Entity type   is required"],
};
export const Masterdatavalue = {
  value_Name: [
    (v) => !!v || "Value Name is required",
    // (v) => /^([A-Za-z0-9()-_]+\s?)*$/.test(v) || "Invalid Value Name",
  ],
  descrption: [(v) => !!v || "Descrption is required"],
  Valuecode: [
    (v) => !!v || "Value Code is required",
    (v) => /^([A-Za-z0-9]+\s?)*$/.test(v) || "Invalid Value Code",
  ],
  parameter_minmax: [(v) => !!v || "required"],
};
export const Masterdata = {
  existingParam: [(v) => !!v || "Select Parameter"],
  Name: [(v) => !!v || "Name is required"],
  descrption: [(v) => !!v || "Descrption is required"],
  parametercode: [
    (v) => !!v || "Parameter Code is required",
    (v) => /^([A-Za-z0-9]+\s?)*$/.test(v) || "Invalid Parameter Code",
  ],
};
export const complianceIND = {
  Risk_Factor: [(v) => !!v || "Risk Factor is required"],
  parameter: [(v) => !!v || "Parameter is required"],
  parameter_Type: [(v) => !!v || "Parameter Type is required"],
};
export const complianceINDvalue = {
  Value: [(v) => !!v || "Value is required"],
  Risk_score: [(v) => !!v || "Score is required"],
};
export const compliancelimits = {
  type: [(v) => !!v || "User type is required"],
  catogry: [(v) => !!v || "User Category is required"],
  Onboard: [(v) => !!v || "Onboard Type is required"],
  Remit: [(v) => !!v || "Remit Type is required"],
  userstats: [(v) => !!v || "Status is required"],
  dailylimitrules: [
    (v) => !!v || "Daily limit is required",
    (v) => /^(([0-9]*){10})$/.test(v) || "Invalid Daily limit",
  ],
  monthlilimitrules: [
    (v) => !!v || "Daily limit is required",
    (v) => /^(([0-9]*){10})$/.test(v) || "Invalid Daily limit",
  ],
};

export const listofRunners = {
  statusRules: [(v) => !!v || "User Status is required"],
  remarksRules: [
    (v) => !!v || "Remarks is required",
    (v) => /^([a-zA-Z0-9!(),:=-_+@]+\s?)*$/.test(v) || "Not a proper comment",
  ],
};
export const indprofile = {
  first_nameRules: [
    (v) => !!v || "First name is required",
    (v) => !/[0-9]/.test(v) || "Invalid First Name",
  ],
  last_nameRules: [
    (v) => !!v || "Last name is required",
    (v) => !/[0-9]/.test(v) || "Invalid Last Name",
  ],
  middle_nameRules: [
    (v) => !!v || "middle name is required",
    (v) => !/[0-9]/.test(v) || "Invalid Middle Name",
  ],
  employe_name: [
    (v) => !!v || "Employer name is required",
    // (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Last Name",
  ],
  idnumberRules: [
    (v) => !!v || "ID Number is required",
    (v) => /^[a-zA-Z0-9]+$/.test(v) || "Invalid ID Number",
  ],
  dobRules: [(v) => !!v || "DOB is required."],
  occupationrules: [(v) => !!v || "Occupation is required"],
  sourceofFundrules: [(v) => !!v || "Source Of Funds is required"],
  nationalityrules: [(v) => !!v || "Nationality is required"],
  addressrule: [
    (v) => !!v || "Address is required",
    (v) => /^([a-zA-Z0-9,.#'-/]+\s?)*$/.test(v) || "Invalid Address",
  ],
  phoneNumbrules: [
    (v) => !!v || "Contact Number is required",
    (v) => /^(([0-9]*){20})$/.test(v) || "The value must be an integer number",
    (v) => (v && v.length >= 8) || "Contact Number must be more than 8 Numbers",
    (v) =>
      (v && v.length < 13) || "Contact Number must be less than 13 Numbers",
  ],
};
export const complianceManage = {
  typeRules: [(v) => !!v || "Type is required"],
  DOBRules: [(v) => !!v || "Date Of Birth is required"],
  nameValidations: [
    (v) => !!v || "Please enter Name.",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Name",
  ],
  fathernameValidations: [
    (v) => !!v || "Please enter Father Name.",
    (v) => /^([a-zA-Z]+\s?)*$/.test(v) || "Invalid Father Name",
  ],
  countryRules: [(v) => !!v || "Country is required"],
  datasourcRules: [(v) => !!v || "Data Source is required"],
  addressValidations: [
    (v) => !!v || "Please enter Address",
    (v) => /^([a-zA-Z0-9,.#'-/]+\s?)*$/.test(v) || "Invalid Address",
  ],
  idType: [(v) => !!v || "Id is required"],
  idnumberValidations: [
    (v) => !!v || "ID Number is required",
    (v) => /^[a-zA-Z0-9]+$/.test(v) || "Invalid ID Number",
  ],
  phonenumberValidations: [
    (v) => !!v || "Contact Number is required",
    (v) => /^(([0-9]*){20})$/.test(v) || "The value must be an integer number",
    (v) => (v && v.length >= 8) || "Contact Number must be more than 8 Numbers",
    (v) =>
      (v && v.length < 13) || "Contact Number must be less than 13 Numbers",
  ],
};
export const LogsManage = {
  ServiceRules: [(v) => !!v || "Service is required"],
  endpointRules: [(v) => !!v || "End Point is required"],
};
export const Beneficiaryvali = {
  firstnameValidations: [
    (v) => !!v || "Please enter first name.",
    (v) => !/[0-9]/.test(v) || "Invalid first name",
  ],
  lastnameValidations: [
    (v) => !!v || "Please enter last name.",
    (v) => !/[0-9]/.test(v) || "Invalid last name",
  ],
  BeneCountryRules: [(v) => !!v || "Benificiary Country is required"],
  Paymentmethod: [(v) => !!v || "Payment Method is required"],
  Bankname: [(v) => !!v || "Bank Name is required"],
  Relationship: [(v) => !!v || "Relationship is required"],
  NativeCountryRules: [(v) => !!v || "Native Country is required"],
  Paymentloction: [(v) => !!v || "Payment Location is required"],
  CityRules: [(v) => !!v || "City is required"],
  ProvineceRules: [(v) => !!v || "Province is required"],
  postalcodeValidations: [
    (v) => !!v || "Please enter postal code.",
    (v) => /^[0-9]+$/.test(v) || "Invalid postal code.",
  ],
  phonenumberValidations: [
    (v) => !!v || "Contact Number is required",
    (v) => /^(([0-9]*){20})$/.test(v) || "The value must be an integer number",
    (v) => (v && v.length >= 8) || "Contact Number must be more than 8 Numbers",
    (v) =>
      (v && v.length < 13) || "Contact Number must be less than 13 Numbers",
  ],
  emailValidations: [
    (v) => !!v || "Please enter E-mail id.",
    (v) =>
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      "Invalid E-mail id.",
  ],
  addressValidations: [
    (v) => !!v || "Please enter Address",
    (v) => /^([a-zA-Z0-9,.#'-/]+\s?)*$/.test(v) || "Invalid Address",
  ],
  IFSCValidations: [
    (v) => !!v || "Please enter IFSC Code",
    (v) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(v) || "Invalid IFSC Code",
  ],
  accountrules: [
    (v) => !!v || "Please enter Account Number .",
    (v) => /^[0-9]+$/.test(v) || "Invalid Account Number.",
  ],
};
